import { render, staticRenderFns } from "./banner1.vue?vue&type=template&id=03a4e045&scoped=true"
import script from "./banner1.vue?vue&type=script&lang=js"
export * from "./banner1.vue?vue&type=script&lang=js"
import style0 from "./banner1.vue?vue&type=style&index=0&id=03a4e045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4e045",
  null
  
)

export default component.exports